import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/LoginScreen.css";
import logo from "../img/logo.png";
import loginImage from "../img/estudo.jpg";
import CardNotification from "../components/CardNotification";
import { useAuth } from "../context/AuthContext";

const LoginScreen = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [cpf, setCpf] = useState("");
  const [senha, setSenha] = useState("");
  const [perfil, setPerfil] = useState("");
  const [tentativas, setTentativas] = useState(0);
  const [statusMessage, setStatusMessage] = useState({ message: "", success: false });
  const [showCard, setShowCard] = useState(false);

  const TEMPO_LIMITE = 2 * 60 * 60 * 1000;

  const checkResetTentativas = () => {
    const ultimoErro = localStorage.getItem("tentativas_timestamp");

    if (ultimoErro) {
      const tempoDecorrido = new Date().getTime() - parseInt(ultimoErro, 10);
      if (tempoDecorrido > TEMPO_LIMITE) {
        localStorage.setItem("tentativas", "0");
        localStorage.removeItem("tentativas_timestamp");
        setTentativas(0);
      }
    }
  };

  useEffect(() => {
    const tentativasSalvas = parseInt(localStorage.getItem("tentativas")) || 0;
    setTentativas(tentativasSalvas);
    checkResetTentativas();

    const intervaloReset = setInterval(checkResetTentativas, TEMPO_LIMITE);
    return () => clearInterval(intervaloReset);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (tentativas >= 30) {
      setStatusMessage({ message: "Número máximo de tentativas atingido. Tente novamente mais tarde.", success: false });
      setShowCard(true);
      return;
    }

    if (perfil === "aluno") {
      loginAluno();
    } else if (perfil === "admin") {
      loginAdmin();
    }
  };

  const loginAluno = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/certificados/${cpf}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Erro ao consultar certificados.");
      const certificadosData = await response.json();

      if (certificadosData && certificadosData.length > 0) {
        localStorage.setItem("alunocpf", cpf);
        navigate("/perfil-aluno");
      } else {
        alert("Você não possui certificados.");
        navigate("/perfil-aluno");
      }
    } catch (error) {
      atualizarTentativas();
      alert(error.message || "Erro ao fazer login!");
    }
  };

  const loginAdmin = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cpf, senha }),
        credentials: "include",
      });

      if (!response.ok) throw new Error("Erro ao fazer login.");
      const data = await response.json();

      if (data) {
        localStorage.setItem("tentativas", "0");
        localStorage.removeItem("tentativas_timestamp");

        localStorage.setItem("user_name", data.usuario.nome);
        localStorage.setItem("instituicao", data.instituicao.nome_instituicao);
        localStorage.setItem("id_instituicao", data.instituicao.id);
        localStorage.setItem("id_usuario", data.usuario.id_usuario);

        login(); // Atualiza o contexto de autenticação

        navigate("/emitir-certificado");
      }
    } catch (error) {
      setStatusMessage({ message: "Senha ou CPF errados, ou perfil inativo.", success: false });
      setShowCard(true);
      atualizarTentativas();
    }
  };

  const atualizarTentativas = () => {
    const novaTentativa = tentativas + 1;
    setTentativas(novaTentativa);
    localStorage.setItem("tentativas", novaTentativa.toString());
    localStorage.setItem("tentativas_timestamp", new Date().getTime().toString());
  };

  useEffect(() => {
    if (showCard) {
      const timer = setTimeout(() => setShowCard(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showCard]);

  return (
    <div className="login-container">
      {statusMessage.message && showCard && (
        <CardNotification
          message={statusMessage.message}
          type={statusMessage.success ? "success" : "error"}
          onClose={() => setShowCard(false)}
        />
      )}

      <div className="login-image">
        <img src={loginImage} alt="Login" />
      </div>

      <div className="login-form-container">
        <img src={logo} alt="Logo" className="login-logo" />

        <form className="login-form" onSubmit={handleLogin}>
          <h2>Login</h2>

          <div className="perfil-select-container">
            <label>Selecione seu perfil</label>
            <select value={perfil} onChange={(e) => setPerfil(e.target.value)} required>
              <option value="">Escolha...</option>
              <option value="aluno">Aluno</option>
              <option value="admin">Administrador</option>
            </select>
          </div>

          <input
            type="text"
            placeholder="Digite seu CPF"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            required
          />

          {perfil === "admin" && (
            <input
              type="password"
              placeholder="Digite sua senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          )}

          <button type="submit">Entrar</button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
